export default __webpack_public_path__ + "static/media/package_3.ea462298.png";